import zh_tw from './zh_tw'
export default {
  zh_tw: zh_tw
}